module.exports = __webpack_public_path__ + "img/a84cab6.webp";